import { useState } from 'react';
import InvestModal from './InvestModal';
import InvestOptionModal from './InvestOptionModal';
import WithdrawModal from './WithdrawModal';
import WithdrawalConfirmModal from './WithdrawalConfirmModal';
import { useFundDispatch, useFundState } from '../../../contexts/FundContext';

const FundModals = () => {
    const fundDispatch = useFundDispatch();
    const fundState = useFundState();

    const [isWithdrawalConfirmModalOpen, setIsWithdrawalConfirmModalOpen] =
        useState(false);
    const [withdrawalRequest, setWithdrawalRequest] = useState();

    const handleOpenWithdrawalConfirmModal = (values) => {
        setWithdrawalRequest(values);
        setIsWithdrawalConfirmModalOpen(true);
    };

    const handleCloseWithdrawalConfirmModal = () => {
        setIsWithdrawalConfirmModalOpen(false);
    };

    return (
        <>
            <InvestOptionModal
                isOpen={fundState.showInvestOptionModal}
                handleClose={() => fundDispatch({ type: 'closeInvestOptionModal' })}
                openInvestModal={() => fundDispatch({ type: 'openInvestModal' })}
            />
            <InvestModal
                isOpen={fundState.showInvestModal}
                investmentNote={fundState.investmentNote}
                handleClose={() => fundDispatch({ type: 'closeInvestModal' })}
            />
            <WithdrawModal
                isOpen={fundState.isWithdrawModalOpen}
                investmentNote={fundState.investmentNote}
                handleClose={() => fundDispatch({ type: 'closeWithdrawModal' })}
                handleOpenConfirmationModal={handleOpenWithdrawalConfirmModal}
            />
            <WithdrawalConfirmModal
                isOpen={isWithdrawalConfirmModalOpen}
                handleClose={handleCloseWithdrawalConfirmModal}
                withdrawalRequest={withdrawalRequest}
            />
        </>
    );
};

export default FundModals;
